import { computed } from 'vue'
import { theme } from 'ant-design-vue'
import type { ThemeConfig } from 'ant-design-vue/es/config-provider/context'
import enUS from 'ant-design-vue/es/locale/en_US'
import viVN from 'ant-design-vue/es/locale/vi_VN'
import { useAppStore } from '@/app/store/app.store'

const BRAND_ORANGE = '#ff9500'

export function useAntTheme() {
  const appStore = useAppStore()

  const antTheme = computed<ThemeConfig>(() => ({
    algorithm: appStore.isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
    token: {
      colorPrimary: BRAND_ORANGE,
      colorInfo: BRAND_ORANGE,
      borderRadius: 6,
      borderRadiusLG: 8,
      controlHeight: 36,
      fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      colorBgLayout: appStore.isDark ? '#0f1115' : '#f5f5f5',
      colorBgContainer: appStore.isDark ? '#17191f' : '#ffffff',
      colorBorderSecondary: appStore.isDark ? '#2a2d35' : '#f0f0f0',
      colorText: appStore.isDark ? '#f5f5f5' : '#1f1f1f',
      colorTextSecondary: appStore.isDark ? '#a8adb7' : '#595959',
    },
    components: {
      Layout: {
        colorBgBody: appStore.isDark ? '#0f1115' : '#f5f5f5',
        colorBgHeader: appStore.isDark ? '#17191f' : '#ffffff',
        colorBgTrigger: appStore.isDark ? '#20232b' : '#fafafa',
      },
      Menu: {
        itemBorderRadius: 6,
        itemHeight: 40,
        itemMarginInline: 8,
        itemSelectedBg: appStore.isDark ? 'rgba(255, 149, 0, 0.18)' : '#fff3e0',
        itemSelectedColor: BRAND_ORANGE,
      },
      Table: {
        headerBg: appStore.isDark ? '#20232b' : '#fafafa',
        headerColor: appStore.isDark ? '#f5f5f5' : '#262626',
        rowHoverBg: appStore.isDark ? '#20232b' : '#fffaf2',
        cellPaddingBlock: 14,
        cellPaddingInline: 16,
      },
      Drawer: { paddingLG: 24 },
      Card: { paddingLG: 20 },
    },
  }))

  const antLocale = computed(() => appStore.locale === 'vi' ? viVN : enUS)

  return { antLocale, antTheme }
}
